/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  EnvironmentOutlined,
  FileTextOutlined,
  PhoneOutlined,
  SearchOutlined,
  SolutionOutlined,
  UserOutlined,
} from '@ant-design/icons';
import {
  DatePicker,
  Form,
  InputNumber,
  Modal,
  Spin,
  Tabs,
} from 'antd';
import { getFuentesDeReclutamiento } from 'api/catalogos/FuentesDeReclutamiento';
import FormSubmitControls from 'components/FormSubmitControls';
import { getCandidato, getEstadosCandidato } from 'api/catalogos/Candidatos';
import { checkToken } from 'api/utils';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { getEstadosCiviles, getGeneros } from 'api/usuarios';
import { getPaises } from 'api/catalogos/paises';
import { getCodigosPostales, getEstados, getMunicipio } from 'api/catalogos';
import { getTiposDeSeguridadSocial } from 'api/catalogos/tipoDeSeguridadSocial';
import { getNacionalidades } from 'api/catalogos/nacionalidades';
import { getTiposDeIdentificaciones } from 'api/catalogos/tiposDeIdentificaciones';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { getTiposDeSeguridadesSociales } from 'api/catalogos/tiposDeSeguridadesSociales';
import { getPreferenciaSPartidarias } from 'api/catalogos/PreferenciaPartidaria';
import Select from 'components/Select';
import {
  CURP_PATTERN, digitoVerificador, RFC_PATTERN, SLUG_PATTERN,
} from 'utils/patterns';
import { getNivelesDeEstudios } from 'api/catalogos/nivelesDeEstudios';
import { getAbreviaturasDeCarreras } from 'api/catalogos/abreviaturasDeCarreras';
import { getComprobantesDeEstudios } from 'api/catalogos/comprobantesDeEstudios';
import { getEspecialidadesDeEstudios } from 'api/catalogos/especialidadesDeEstudios';
import CandidatoGeneral from '../CandidatoGeneral';
import CandidatoFiliacion from '../CandidatoFiliacion';
import CandidatoContacto from '../CandidatoContacto';
import DocumentosCandidato from './DocumentosCanditato';
import CandidatosEstudios from './CandidatosEstudios';
import DireccionesCandidato from './DireccionCandidatos';

const { TabPane } = Tabs;

// Ficha del Candidato en modo SOLO LECTURA. Replica el flujo de "handleVerFicha"
// de CandidatosPorVacante, pero como componente autónomo para poder abrirlo desde
// otras vistas (p. ej. ContratacionCandidatos) sin duplicar la lógica de edición.
export default function FichaCandidatoView({ open, onClose, candidatoId }) {
  const [form] = Form.useForm();
  const [formFiliacion] = Form.useForm();
  const [formDireccion] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [candidatoSeleccionado, setCandidatoSeleccionado] = useState(null);
  const [currentParentTabKey, setCurrentParentTabKey] = useState('general');
  const [esEmpleadoMunicipio, setEsEmpleadoMunicipio] = useState(false);
  const [esReingreso, setEsReingreso] = useState(false);
  const [requiereModificar, setRequiereModificar] = useState(false);

  // Catálogos
  const [estadoscandidato, setEstadosCandidato] = useState([]);
  const [fuentesDeReclutamiento, setFuentesDeReclutamiento] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [estadoCivil, setEstadoCivil] = useState([]);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [tiposSeguridadSocial, setTiposSeguridadSocial] = useState([]);
  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tiposDeIdentificaciones, setTiposDeIdentificaciones] = useState([]);
  const [tiposDeSeguridadesSociales, setTiposDeSeguridadesSociales] = useState([]);
  const [preferenciaPartidaria, setPreferenciaPartidaria] = useState([]);
  const [coloniasCargadas, setColoniasCargadas] = useState([]);
  const [nivelesDeEstudios, setNivelesDeEstudios] = useState([]);
  const [abreviaturasDeCarreras, setAbreviaturasDeCarreras] = useState([]);
  const [comprobantesDeEstudios, setComprobantesDeEstudios] = useState([]);
  const [especialidadesDeEstudios, setEspecialidadesDeEstudios] = useState([]);

  const calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento) return null;
    const hoy = moment();
    const nacimiento = moment(fechaNacimiento);
    if (!nacimiento.isValid()) return null;
    return hoy.diff(nacimiento, 'years');
  };

  const normalizarCandidato = (data) => {
    if (!data) return {};

    return {
      ...data,
      id: data.id,
      numero_de_candidato: data.numero_de_candidato ?? null,
      nombre: data.nombre ?? '',
      apellido_paterno: data.apellido_paterno ?? '',
      apellido_materno: data.apellido_materno ?? '',

      curp: data.curp ?? data.CURP ?? '',
      RFC: data.RFC ?? '',

      correo_electronico: data.correo_electronico ?? '',
      numero_de_telefono: data.numero_de_telefono ?? '',
      numero_de_celular: data.numero_de_celular ?? '',

      fecha_de_nacimiento: data.fecha_de_nacimiento
        ? moment(data.fecha_de_nacimiento, 'YYYY-MM-DD')
        : null,

      genero: data.genero ?? null,
      estado_civil: data.estado_civil ?? null,
      nacionalidad: data.nacionalidad ?? null,
      pais: data.pais ?? null,

      estado_nacimiento: data.estado_nacimiento ?? null,
      lugar_de_nacimiento: data.lugar_de_nacimiento ?? null,

      tiene_hijos: data.tiene_hijos ?? null,
      tipo_de_identificacion: data.tipo_de_identificacion ?? null,
      numero_de_identificacion: data.numero_de_identificacion ?? null,

      codigo_postal: data.codigo_postal ?? null,
      colonia: data.colonia ?? null,

      tipo_de_seguridad_social: data.tipo_de_seguridad_social ?? null,
      numero_de_seguridad_social: data.numero_de_seguridad_social ?? null,

      estado_del_candidato: data.estado_del_candidato?.id ?? data.estado_del_candidato ?? null,

      solicitud_de_contratacion: data.solicitud_de_contratacion?.id ?? data.solicitud_de_contratacion ?? null,

      fuente_de_reclutamiento: data.fuente_de_reclutamiento?.id ?? data.fuente_de_reclutamiento ?? null,

      referente: data.referente ?? null,

      nivel_de_estudios: data.nivel_de_estudios ?? null,
      abreviatura: data.abreviatura ?? null,
      comprobante: data.comprobante ?? null,
      estudios_concluidos: data.estudios_concluidos ?? false,
      numero_de_cedula_profesional: data.numero_de_cedula_profesional ?? null,
      especialidad_estudio: data.especialidad_estudio ?? null,

      es_empleado_del_municipio: data.es_empleado_del_municipio ?? false,
      es_reingreso: data.es_reingreso ?? false,
      requiere_modificar_datos: data.requiere_modificar_datos ?? false,
      fecha_de_alta: data.fecha_de_alta ? moment(data.fecha_de_alta, 'YYYY-MM-DD') : null,
      fecha_de_reingreso: data.fecha_de_reingreso ? moment(data.fecha_de_reingreso, 'YYYY-MM-DD') : null,
      numero_de_empleado: data.numero_de_empleado ?? null,
    };
  };

  // Carga de catálogos (una sola vez al montar).
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      await checkToken();
      try {
        const [
          _estadoscandidato,
          _fuentesDeReclutamiento,
          _generos,
          _paises,
          _estados,
          _estadosCivil,
          _tiposSeguridadSocial,
          _nacionalidades,
          _tiposDeIdentificaciones,
          _tiposDeSeguridadesSociales,
          _preferenciaPartidaria,
          _nivelesDeEstudios,
          _abreviaturasDeCarreras,
          _comprobantesDeEstudios,
          _especialidadesDeEstudios,
        ] = await Promise.all([
          getEstadosCandidato(),
          getFuentesDeReclutamiento(),
          getGeneros(),
          getPaises(),
          getEstados(),
          getEstadosCiviles(),
          getTiposDeSeguridadSocial(),
          getNacionalidades(),
          getTiposDeIdentificaciones({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposDeSeguridadesSociales({ estados_globales: ESTATUS_AUTORIZADO }),
          getPreferenciaSPartidarias(),
          getNivelesDeEstudios({ estados_globales: ESTATUS_AUTORIZADO }),
          getAbreviaturasDeCarreras({ estados_globales: ESTATUS_AUTORIZADO }),
          getComprobantesDeEstudios({ estados_globales: ESTATUS_AUTORIZADO }),
          getEspecialidadesDeEstudios({ estados_globales: ESTATUS_AUTORIZADO }),
        ]);
        if (mounted) {
          setEstadosCandidato(_estadoscandidato);
          setFuentesDeReclutamiento(_fuentesDeReclutamiento);
          setGeneros(_generos);
          setPaises(_paises);
          setEstados(_estados);
          setEstadoCivil(_estadosCivil);
          setTiposSeguridadSocial(_tiposSeguridadSocial);
          setNacionalidades(_nacionalidades);
          setTiposDeIdentificaciones(_tiposDeIdentificaciones);
          setTiposDeSeguridadesSociales(_tiposDeSeguridadesSociales);
          setPreferenciaPartidaria(_preferenciaPartidaria);
          setNivelesDeEstudios(_nivelesDeEstudios);
          setAbreviaturasDeCarreras(_abreviaturasDeCarreras);
          setComprobantesDeEstudios(_comprobantesDeEstudios);
          setEspecialidadesDeEstudios(_especialidadesDeEstudios);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[Ficha Candidato] error al cargar catálogos', err);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  // Carga del candidato cada vez que se abre la ficha con un id.
  useEffect(() => {
    let mounted = true;
    const cargarCandidato = async () => {
      if (!open || !candidatoId) return;
      setLoading(true);
      setCurrentParentTabKey('general');
      try {
        const candidatoApi = await getCandidato(candidatoId);
        const normalizado = normalizarCandidato(candidatoApi);

        setEsEmpleadoMunicipio(normalizado.es_empleado_del_municipio);
        setEsReingreso(normalizado.es_reingreso);
        setRequiereModificar(normalizado.requiere_modificar_datos);

        form.resetFields();
        formFiliacion.resetFields();
        formDireccion.resetFields();

        if (normalizado.lugar_de_nacimiento) {
          const _municipio = await getMunicipio(normalizado.lugar_de_nacimiento);
          normalizado.estado_nacimiento = _municipio?.estado?.id ?? null;
        }

        if (normalizado.codigo_postal) {
          const cps = await getCodigosPostales({ id: normalizado.codigo_postal });
          if (cps?.length) {
            const first = cps[0];
            formFiliacion.setFieldsValue({
              codigo_postal: normalizado.codigo_postal,
              d_codigo: first.d_codigo,
              estado: first?.municipio?.estado?.nombre_de_AGEE || '',
              municipio: first?.municipio?.nom_mun || '',
            });
          }
        }

        form.setFieldsValue(normalizado);
        formFiliacion.setFieldsValue(normalizado);

        if (normalizado.fecha_de_nacimiento) {
          form.setFieldsValue({ edad: calcularEdad(normalizado.fecha_de_nacimiento) });
        }

        if (mounted) setCandidatoSeleccionado(normalizado);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[Ficha Candidato] error al cargar el candidato', err);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    cargarCandidato();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [open, candidatoId]);

  const handleClose = () => {
    form.resetFields();
    formFiliacion.resetFields();
    formDireccion.resetFields();
    setCandidatoSeleccionado(null);
    setEsEmpleadoMunicipio(false);
    setEsReingreso(false);
    setRequiereModificar(false);
    onClose();
  };

  const requiredRule = { required: true, message: 'El campo es requerido' };

  const rules = {
    required: [requiredRule],
    clave: [requiredRule, { pattern: SLUG_PATTERN, message: 'Ingrese un número de empleado válido' }],
    RFC: [requiredRule, { pattern: RFC_PATTERN, message: 'Ingrese un RFC válido' }],
    curp: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (value) {
            const validado = value.toUpperCase().match(CURP_PATTERN);
            if (!validado || validado[2] !== digitoVerificador(validado[1])) {
              throw new Error('Ingrese una CURP válida');
            }
          }
        },
      },
    ],
    telefono: [
      {
        validator: async (rule, value) => {
          if (value) {
            const numeroEnteroBooleano = /^\d+$/.test(value);
            const cantidadDeCaracteres = value.length;
            if (!numeroEnteroBooleano || cantidadDeCaracteres !== 10) {
              throw new Error('Ingrese un número válido de 10 dígitos');
            }
          }
        },
      },
    ],
    correo_electronico: [requiredRule, { type: 'email', message: 'Ingrese un correo válido' }],
  };

  return (
    <Modal
      open={open}
      closable={false}
      maskClosable={!loading}
      keyboard={!loading}
      footer={null}
      forceRender
      width={1000}
      title={(
        <FormSubmitControls
          label="Ficha del Candidato"
          onCancel={handleClose}
          loading={false}
          allowSave={false}
        />
      )}
      onCancel={handleClose}
    >
      <Spin tip="Cargando..." spinning={loading}>
        <Form layout="vertical" form={form}>
          <Tabs
            activeKey={currentParentTabKey}
            onChange={setCurrentParentTabKey}
          >
            <TabPane
              tab={(
                <span>
                  <SearchOutlined />
                  {' '}
                  Previo
                </span>
)}
              key="empleado"
              forceRender
            >
              <Form layout="vertical" form={form} name="previo_ficha">
                <Form.Item
                  name="es_empleado_del_municipio"
                  label="¿Es empleado actual del Municipio de Tlajomulco?"
                >
                  <Select trueFalse disabled />
                </Form.Item>
                {(esEmpleadoMunicipio || esReingreso) && (
                  <Form.Item name="numero_de_empleado" label="Número de Empleado">
                    <InputNumber style={{ width: '100%' }} disabled />
                  </Form.Item>
                )}
                {!esEmpleadoMunicipio && !esReingreso && (
                  <Form.Item name="fecha_de_alta" label="Fecha de Alta">
                    <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" disabled />
                  </Form.Item>
                )}
                <Form.Item name="es_reingreso" label="¿Es Reingreso de Empleado?">
                  <Select trueFalse disabled />
                </Form.Item>
                <Form.Item name="requiere_modificar_datos" label="¿Requiere Modificar Datos del Empleado?">
                  <Select trueFalse disabled />
                </Form.Item>
                {esReingreso && (
                  <Form.Item name="fecha_de_reingreso" label="Fecha de Reingreso">
                    <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" disabled />
                  </Form.Item>
                )}
              </Form>
            </TabPane>

            <TabPane
              tab={(
                <span>
                  <UserOutlined />
                  {' '}
                  General
                </span>
)}
              key="general"
              forceRender
            >
              <CandidatoGeneral
                form={form}
                formFiliacion={formFiliacion}
                rules={rules}
                selectedRowKeys={candidatoSeleccionado}
                generos={generos}
                estados={estados}
                estadoCivil={estadoCivil}
                nacionalidades={nacionalidades}
                paises={paises}
                calcularEdad={calcularEdad}
                estadosCandidato={estadoscandidato}
                isBlocked
              />
            </TabPane>

            <TabPane
              tab={(
                <span>
                  <FileTextOutlined />
                  {' '}
                  Filiación
                </span>
)}
              key="filiacion"
              forceRender
            >
              <CandidatoFiliacion
                form={form}
                formFiliacion={formFiliacion}
                tiposDeIdentificaciones={tiposDeIdentificaciones}
                tiposDeSeguridadesSociales={tiposDeSeguridadesSociales}
                fuentesDeReclutamiento={fuentesDeReclutamiento}
                rules={rules}
                preferenciaPartidaria={preferenciaPartidaria}
                coloniasCargadas={coloniasCargadas}
                isBlocked
              />
            </TabPane>

            <TabPane
              tab={(
                <span>
                  <PhoneOutlined />
                  {' '}
                  Contacto
                </span>
)}
              key="contacto"
              forceRender
            >
              <CandidatoContacto
                form={form}
                rules={rules}
                isBlocked
              />
            </TabPane>

            <TabPane
              tab={(
                <span>
                  <EnvironmentOutlined />
                  {' '}
                  Dirección
                </span>
)}
              key="direccion"
              forceRender
              disabled={!candidatoSeleccionado?.id}
            >
              <DireccionesCandidato
                formDireccion={formDireccion}
                rules={rules}
                coloniasCargadas={coloniasCargadas}
                paises={paises}
                candidatoId={candidatoSeleccionado?.id}
              />
            </TabPane>

            <TabPane
              tab={(
                <span>
                  <FileTextOutlined />
                  {' '}
                  Estudios
                </span>
)}
              key="estudios"
              forceRender
            >
              <CandidatosEstudios
                form={form}
                rules={rules}
                nivelesDeEstudios={nivelesDeEstudios}
                abreviaturasDeCarreras={abreviaturasDeCarreras}
                comprobantesDeEstudios={comprobantesDeEstudios}
                especialidadesDeEstudios={especialidadesDeEstudios}
                isBlocked
              />
            </TabPane>

            <TabPane
              tab={(
                <span>
                  <SolutionOutlined />
                  {' '}
                  Documentos
                </span>
)}
              key="documentos"
              forceRender
              disabled={!candidatoSeleccionado?.id}
            >
              <DocumentosCandidato
                candidatoId={candidatoSeleccionado?.id}
                formEmpleado={form}
                rules={rules}
              />
            </TabPane>
          </Tabs>
        </Form>
      </Spin>
    </Modal>
  );
}
